import chroma from "chroma-js";
const grayScale = (colorStart, colorEnd) => {
  const gray = {
    10: "",
    20: "",
    30: "",
    40: "",
    50: "",
    60: "",
    70: "",
    80: "",
    90: "",
    100: ""
  };
  const scale = chroma.scale([colorStart, colorEnd]).colors(10);
  scale.forEach((tint, index) => {
    const key = (index + 1) * 10;
    gray[key] = tint;
  });
  return gray;
};
export default grayScale;
